import { useState } from 'react';

export const useOnValueChanged = <T extends readonly unknown[]>({
    condition = true,
    onChange,
    values,
}: {
    values: T;
    onChange?: (values: T) => void;
    condition?: boolean;
}): boolean[] => {
    const [prevValues, setPrevValues] = useState(values);
    const hasSomeValueChanged = values.some((value, index) => !Object.is(value, prevValues[index]));
    if (hasSomeValueChanged) {
        setPrevValues(values);
        if (onChange && condition) onChange(values);
    }
    const changeStatus = values.map((value, index) => Object.is(value, prevValues[index]));
    return changeStatus;
};
